import React from 'react'
import ReactDOM from 'react-dom/client'
import { App } from './app/App'
import './app/globals.css'
import './styles/print.css'
import './i18n/config'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)
